import { SurveyOptionSchema } from "./SurveyOption";
import { z } from "zod";

export type Survey = z.infer<typeof SurveySchema>;
export const SurveySchema = z.object({
  type: z.literal("rating"),
  options: z.array(SurveyOptionSchema),
  low_label: z.string(),
  high_label: z.string(),
});
